import React, {Component} from 'react'
import StyleSheet from 'styles'
import { Link } from 'react-router-dom'
import { AuditLogActions, UserActions } from 'actionsets'
import { connect } from 'react-redux'
import {connectQueryString} from 'containers/shared'
import CenteredContent from 'containers/CenteredContent'
import Dependent from 'containers/shared/Dependent'
import Typography from '@material-ui/core/Typography'
import {DateTimeDisplay} from 'components/DateTimeDisplay'
import Table, { TableHead, TableBody, TableRow, TableCell, styles as tableStyles } from 'components/CollapsibleTable'
import {
  SearchComboInput,
  Pagination,
  SortedTableHead,
  DateTimePicker, InfoDialog, AutoSuggestField, MultiSelect,
} from 'components'
import TextField from '@material-ui/core/TextField/TextField'
import {humanize} from 'utils'

export class List extends Component {
  constructor(props) {
    super(props)
    AuditLogActions.bindActions(this)
    UserActions.bindActions(this, 'user')
    this.state = {}
  }

  dependsOn = () => {
    return this.actions.index({...this.props, filter: this.filter})
  }

  dependenciesMet = () => {
    return this.props.requests.length === 0
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.query !== prevProps.query)
      this.dependsOn()
  }

  get filter() {
    const {filter, filter: {event}} = this.props
    return {...filter, event: (!event || Array.isArray(event)) ? event : [event] }
  }

  get changeset() {
    const changes = (this.state.showAuditLog && this.state.showAuditLog.changeset) || {}
    return Object.keys(changes).map(k => ({field: k, from: changes[k][0], to: changes[k][1]}))
  }

  findUser = (id) => {
    const users = (this.props.search && this.props.search.results) || []
    const whodunnits = this.props.auditLogs.map(audit => audit.user)
    return users.concat(whodunnits).find(user => `${user.id}` === id) || {id: id, name: id}
  }

  render = () => {
    const {auditLogs, page, onPageChange, totalPages, onFilterChange, order, onOrderChange} = this.props
    return (
      <CenteredContent>
        <Typography variant="h5">Audit Log</Typography>
        <div className={styles.filterBar}>
          <SearchComboInput onFilterChange={onFilterChange} filter={this.filter}>
            <div>
              <TextField label='Entity' member='item_type' fullWidth={false}/>
              <TextField label='ID' member='item_id' fullWidth={false}/>
            </div>
            <div>
              <AutoSuggestField
                labelProvider={({name}) => name}
                valueProvider={({id}) => id}
                objectProvider={this.findUser}
                suggestionProvider={free_text => this.actions.user.search({filter: {free_text}})}
                member="whodunnit"
                label="User"
              />
            </div>
            <div>
              <DateTimePicker label='Start Time' member='created_at.start' showDate showTime/>
              <DateTimePicker label='End Time' member='created_at.end' showDate showTime/>
            </div>
            <div className={styles.eventFilters}>
              <Typography variant="subtitle1">Events</Typography>
              <MultiSelect member="event" options={everyEvent} defaultOptions={everyEvent} unsetWhenDefault/>
            </div>
          </SearchComboInput>
        </div>
        <Table>
          <SortedTableHead onOrderChange={onOrderChange} order={order}>
            <TableRow>
              <TableCell orderBy='item_type'>Entity</TableCell>
              <TableCell orderBy='item_id'>ID</TableCell>
              <TableCell orderBy='event'>Event</TableCell>
              <TableCell orderBy='whodunnit'>User</TableCell>
              <TableCell orderBy='created_at'>Time</TableCell>
            </TableRow>
          </SortedTableHead>
          <TableBody>
            {auditLogs.map(auditLog =>
              <TableRow key={auditLog.id}>
                <TableCell mobileHeading>{humanize(auditLog.itemType)}</TableCell>
                <TableCell mobileLabel="ID">{auditLog.itemId}</TableCell>
                <TableCell mobileLabel="Event">
                  {auditLog.changeset && Object.keys(auditLog.changeset).length > 0 ?
                    <a href="#action" onClick={() => this.setState({showAuditLog: auditLog})}>{humanize(auditLog.event)}</a>
                    :
                    humanize(auditLog.event)
                  }
                </TableCell>
                <TableCell mobileLabel="User">
                  {(auditLog.user && auditLog.user.name) ?
                    <Link to={`/users/${auditLog.user.id}/edit`}>{auditLog.user.name}</Link>
                    :
                    'System'
                  }
                </TableCell>
                <TableCell mobileLabel="Time"><DateTimeDisplay value={auditLog.createdAt} type="datetime" singleLine/></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Pagination totalPages={totalPages} onPageSelected={onPageChange} page={page}/>
        <InfoDialog title="Changes" onClose={() => this.setState({showAuditLog: null})} open={!!this.state.showAuditLog}>
          <Table breakpoint={400} className={styles.diffTable}>
            <TableHead>
              <TableRow>
                <TableCell>Field</TableCell>
                <TableCell>Old Value</TableCell>
                <TableCell>New Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.changeset.map(change =>
                <TableRow key={change.field}>
                  <TableCell mobileHeading>{humanize(change.field)}</TableCell>
                  <TableCell mobileLabel="Old Value">{change.from}</TableCell>
                  <TableCell mobileLabel="New Value">{change.to}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </InfoDialog>
      </CenteredContent>
    )
  }

}

export default connect(({auditLogs, users}) => ({...users, ...auditLogs}))(connectQueryString(Dependent({loader: true})(List)))

const everyEvent = ['create', 'update', 'delete', 'user_actions']

const styles = StyleSheet({
  filterBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  diffTable: {
    [`&.${tableStyles.collapsed}`]: {
      width: 'auto',
      marginLeft: -24,
      marginRight: -24,
    }
  },
  eventFilters: {
    '& > aside': {
      display: 'inline-block',
      marginLeft: -12,
      marginRight: 25,
    }
  }
})